<template>
  <div class="container">
    <div class="line">
      <label>Päivämäärä:</label><span>{{displayDate}}</span>
    </div>
    <div class="line">
      <label>Otsikko:</label><span>{{booking.title}}</span>
    </div>
    <!-- <div class="line">
      <label>Kuvaus:</label><span>Tämä on pitkä testikuvaus. Tilaisuudessa käsitellään asioita jotka liittyvät viikon 16 suunnitteluun ja toteuttamiseen.</span>
    </div> -->
    <div class="line">
      <label>Aika:</label><span>{{booking.start}} - {{booking.end}}</span>
    </div>
    <div class="line">
      <label>Varaaja:</label><span>{{booking.who}}</span>
    </div>
    <div class="line">
      <label>Sähköposti:</label><span>{{booking.email}}</span>
    </div>
  </div>
</template>

<script>

import TimeUtils from './../utils/TimeUtils';

export default {
  name: 'BookingInfoDisplay',
  props: [ 'booking' ],
  computed: {
    displayDate () {
      return TimeUtils.toFIN(this.booking.date);
    }
  }
}
</script>

<style lang="scss" scoped>

  .container {
    max-width: 30em;
    margin: 0 auto;
  }
  .line {
    display: flex;
    justify-content: center;
    padding-bottom: 0.5em;

    label {
      flex: 1;
      padding-right: 0.5em;
      text-align: right;
    }
    span {
      flex: 1;
      text-align: left;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/BookingInfoDisplay.vue